import { extendTheme } from '@chakra-ui/react';
import { isDJ } from 'utils';
import { sharedTheme } from './shared';

export const baseChakraTheme = extendTheme({
  styles: {
    global: {
      body: {
        fontFamily: sharedTheme.fonts.body,
        color: isDJ() ? 'black' : sharedTheme.colors.indigo,
      },
    },
  },
  Component: {
    ChText: {
      color: isDJ() ? 'black' : sharedTheme.colors.indigo,
    },
  },
});
